// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__chvQN","controls":"form_controls__1hDdO","opacity-transition":"form_opacity-transition__ukFKH"};